var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3507 0.494652L19.6146 1.7586C20.1285 2.27244 20.1285 3.11136 19.6146 3.6252L18.9822 4.25765L15.8516 1.12806L16.4841 0.495605C16.9979 -0.0182366 17.8377 -0.0182366 18.3507 0.494675V0.494652ZM3.61756 0.480702C1.62771 0.480702 0 2.10845 0 4.09827V16.2723C0 18.2621 1.62775 19.8898 3.61852 19.8898H15.7925C17.7814 19.8898 19.4101 18.2621 19.4101 16.2723V6.56053L17.286 8.68367V16.2724C17.286 17.0946 16.6138 17.766 15.7925 17.766H3.61772C2.79555 17.766 2.1233 17.0937 2.1233 16.2724V4.09842C2.1233 3.27625 2.79555 2.604 3.61772 2.604H11.6446L13.7677 0.480861L3.61756 0.480702ZM7.24429 12.8646L7.75627 11.0295L8.26733 9.19342L9.5914 10.5184L10.9155 11.8425L9.08034 12.3545L7.24429 12.8646ZM18.3199 4.91833L15.1894 1.78874L8.68868 8.28943L11.8183 11.419L18.3199 4.91833Z",
    fill: "#3582D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlueIcon);
export default __webpack_public_path__ + "static/media/edit-blue-icon.50dffbed3ce1e085d7b94474fba19a70.svg";
export { ForwardRef as ReactComponent };